import React from 'react';
import { useSelector } from 'react-redux';
import { formatStationList } from '@/utils/util';
import { tabKeys, VehicleBusinessType } from '@/utils/constant';
import Monitor from './Monitor';
import { RootState } from '@/redux/store';
import StopRouteMap from '@/components/RoadStation/stopRouteMap';
import WorkOrderRecord from '../WorkOrderRecord';
import EventRecord from '../EventRecord';
import ManualEventRecord from '../ManualEventRecord';
import MapVariableIssue from '@/components/MapVariableIssue';

interface Props {
  activeKey: string;
  license: string;
  mapData: any;
  handleChangeMapType: AnyFunc;
  toggleStartOrStopVehiclePosition: AnyFunc;
}
const MapBox = (props: Props) => {
  const {
    activeKey,
    license,
    mapData,
    handleChangeMapType,
    toggleStartOrStopVehiclePosition,
  } = props;
  const singleVehiclePageInfo = useSelector(
    (state: RootState) => state.singleVehiclePageInfo
  );
  const workOrder = useSelector((state: RootState) => state.workOrder);
  const {
    vehicleRealTimeInfo,
    vehicleBasicInfoNew,
    scheduleRealTime,
    alarmEventList,
  } = singleVehiclePageInfo;
  const stopList = formatStationList(vehicleRealTimeInfo, scheduleRealTime);
  const mapVariableIssue = alarmEventList?.filter(
    (item: any) => item.alarmEvent === 'ATTENTION_REGION_WARN'
  );

  return (
    <div className="map-view">
      <div className="tab-container">
        {activeKey === tabKeys.threeDimension && (
          <>
            <Monitor
              mapData={mapData}
              license={license}
              handleChangeMapType={handleChangeMapType}
              toggleStartOrStopVehiclePosition={
                toggleStartOrStopVehiclePosition
              }
            />
            <MapVariableIssue
              visible={
                mapVariableIssue?.length > 0 &&
                vehicleRealTimeInfo?.mapVariableRemark
              }
              message={vehicleRealTimeInfo?.mapVariableRemark}
            />
          </>
        )}
        {activeKey === tabKeys.workOrderRecord && (
          <WorkOrderRecord vehicleName={license} />
        )}
        {activeKey === tabKeys.eventRecord && (
          <EventRecord vehicleName={license} />
        )}
        {activeKey === tabKeys.manualEventRecord && (
          <ManualEventRecord vehicleName={license} />
        )}
      </div>
      {vehicleBasicInfoNew &&
        activeKey === tabKeys.threeDimension &&
        vehicleBasicInfoNew.businessType !== VehicleBusinessType.VENDING && (
          <StopRouteMap
            stopList={stopList}
            taskType={vehicleRealTimeInfo.taskType}
          ></StopRouteMap>
        )}
    </div>
  );
};
export default React.memo(MapBox);
